import { ComplexValue } from 'app/types-shared';
import { SavedReport, SavedReportValidation } from './types-store';

export const ACTION = {
  REQUEST_REPORT_EVALUATION: 'SAVED_REPORTS:REQUEST_REPORT_EVALUATION',
  RECEIVE_REPORT_EVALUATION: 'SAVED_REPORTS:RECEIVE_REPORT_EVALUATION',
  FAIL_REPORT_EVALUATION: 'SAVED_REPORTS:FAIL_REPORT_EVALUATION',

  SELECT_CURRENT_SAVED_REPORT: 'SAVED_REPORTS:SELECT_CURRENT_SAVED_REPORT',
  UPDATE_CURRENT_SAVED_REPORT: 'SAVED_REPORTS:UPDATE_CURRENT_SAVED_REPORT',
  UPDATE_CURRENT_VALIDATION: 'SAVED_REPORTS:UPDATE_CURRENT_VALIDATION',

  REQUEST_ADD_SAVED_REPORTS: 'SAVED_REPORTS:REQUEST_ADD_SAVED_REPORTS',
  RECEIVE_ADD_SAVED_REPORTS: 'SAVED_REPORTS:RECEIVE_ADD_SAVED_REPORTS',
  FAIL_ADD_SAVED_REPORTS: 'SAVED_REPORTS:FAIL_ADD_SAVED_REPORTS',

  UPDATE_SAVED_REPORT: 'SAVED_REPORTS:UPDATE_SAVED_REPORT',
  DELETE_SAVED_REPORT: 'SAVED_REPORTS:DELETE_SAVED_REPORT',
  DELETE_ALL_SAVED_REPORTS: 'SAVED_REPORTS:DELETE_ALL_SAVED_REPORTS',

  SWITCH_DISPLAY_DISABLED: 'SAVED_REPORTS:SWITCH_DISPLAY_DISABLED',

  UPDATE_VALIDATION: 'SAVED_REPORTS:UPDATE_VALIDATION'
};

export class RequestReportEvaluation {
  public type: string = ACTION.REQUEST_REPORT_EVALUATION;
  constructor(
    public component: string,
    public typeId: number,
    public favouriteId: number
  ) { }
}

export class ReceiveReportEvaluation {
  public type: string = ACTION.RECEIVE_REPORT_EVALUATION;
  constructor(
    public component: string,
    public typeId: number,
    public favouriteId: number,
    public reportCode: ComplexValue<number>,
    public selectedReport: number,
    public editable: boolean,
    public validation: SavedReportValidation
  ) { }
}

export class FailReportEvaluation {
  public type: string = ACTION.FAIL_REPORT_EVALUATION;
  constructor(
    public component: string,
    public typeId: number,
    public favouriteId: number
  ) { }
}

export class SelectCurrentSavedReports {
  public type: string = ACTION.SELECT_CURRENT_SAVED_REPORT;
  constructor(
    public component: string,
    public savedReport: SavedReport,
    public onlyIdMode: boolean
  ) { }
}

export class UpdateCurrentSavedReports {
  public type: string = ACTION.UPDATE_CURRENT_SAVED_REPORT;
  constructor(
    public component: string,
    public savedReport: Partial<SavedReport>
  ) { }
}

export class UpdateCurrentValidation {
  public type: string = ACTION.UPDATE_CURRENT_VALIDATION;
  constructor(
    public component: string,
    public validation: SavedReportValidation
  ) { }
}

export class RequestAddSavedReports {
  public type: string = ACTION.REQUEST_ADD_SAVED_REPORTS;
  constructor(public component: string) { }
}

export class ReceiveAddSavedReports {
  public type: string = ACTION.RECEIVE_ADD_SAVED_REPORTS;
  constructor(
    public component: string,
    public savedReports: SavedReport[]
  ) { }
}

export class FailAddSavedReports {
  public type: string = ACTION.FAIL_ADD_SAVED_REPORTS;
  constructor(public component: string) { }
}

export class UpdateSavedReport {
  public type: string = ACTION.UPDATE_SAVED_REPORT;
  constructor(
    public component: string,
    public currentSavedReportId: number,
    public savedReport: SavedReport,
    public validation: SavedReportValidation
  ) { }
}

export class DeleteSavedReport {
  public type: string = ACTION.DELETE_SAVED_REPORT;
  constructor(
    public component: string,
    public savedReportId: number
  ) { }
}

export class DeleteAllSavedReports {
  public type: string = ACTION.DELETE_ALL_SAVED_REPORTS;
  constructor(public component: string) { }
}

export class SwitchDisplayDisabled {
  public type: string = ACTION.SWITCH_DISPLAY_DISABLED;
  constructor(
    public component: string,
    public displayDisabled: boolean
  ) { }
}

export class UpdateSavedReportValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(
    public component: string,
    public validation: { [savedReportId: number]: SavedReportValidation }
  ) { }
}
